













import { Vue, Component, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentEntity } from '@/api/tournament'
import OverlayTabs from '@/modules/shared/components/OverlayTabs'
import { TabItem } from '@/modules/shared/components/OverlayTabs/OverlayTabs.vue'
import { RawLocation } from 'vue-router'
import { isElectron } from '@/utils/electron'

@Component({
  components: { OverlayTabs }
})
export default class OverlayMemberProfile extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  items: TabItem[] = []
  mobileItems: TabItem[] = []

  currentTab: number = 0

  created() {
    this.items = [
      {
        name: this.$t('OverlayMemberProfile.ItemMatchHistory'),
        slot: 'match-history',
        to: {
          name: 'MemberMatchHistory'
        } as RawLocation
      },
      {
        name: this.$t('OverlayMemberProfile.ItemTournamentHistory'),
        slot: 'tournament-history',
        to: {
          name: 'MemberTournamentHistory'
        } as RawLocation
      }
    ]
    this.mobileItems = [
      {
        name: this.$t('OverlayMemberProfile.Profile'),
        slot: 'member-profile',
        to: {
          name: 'MemberMatchHistory'
        } as RawLocation
      }
    ]

    if (isElectron()) {
      this.items = [
        ...this.items,
        {
          name: this.$t('OverlayMemberProfile.ItemHomeShop'),
          slot: 'home-shop',
          to: {
            name: 'HomeShopMain'
          } as RawLocation
        }
      ]
    }

    this.updateDefaultTab()
  }

  updateDefaultTab() {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].slot === this.$route.meta.defaultTab) {
        this.currentTab = i + 1
      }
    }
  }

  @Watch('$route')
  onRouteChanged() {
    this.updateDefaultTab()
  }

  /* Vuex State */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  async onSelect(route: RawLocation) {
    try {
      await this.$router.push(route)
    } catch {
      await this.$router.push({
        name: 'MemberMatchHistory'
      })
    }
  }
}
